 // eslint-disable-next-line no-undef
const ajaxUrl = map_block_object.ajax_url;
let mapObj;

import { map, 
         orderBy, 
         uniqWith,
         filter, 
         cloneDeep,
         omitBy,
         uniqBy,
         union,
         sortBy} from 'lodash';

function initCareers(career) {

  const slcLocation = career.querySelector('.block-careers__filter .form-select.location');
  const slcEmployment = career.querySelector('.block-careers__filter .form-select.employment-type');
  const slcJobType = career.querySelector('.block-careers__filter .form-select.job-type');
  const careerContainer = career.querySelector('.block-careers__hr-openings');
  const btnClearFilters = career.querySelector('.block-careers__filter .wp-block-button__link.clear-filters');

  let breezyCareers,
      postData;

   // eslint-disable-next-line no-undef
  const postsApiRequest = apiRequestJSON('GET', ajaxUrl , 'get_posts_by_filters',
    // eslint-disable-next-line no-undef
    {post_type: 'locations', posts_per_page: '-1', nonce: map_block_object.nonce});

  // Determine careers API source based on provider
  // eslint-disable-next-line no-undef
  const hrProvider = map_block_object.hr_provider || 'breezy';
  let breezyCareersApiRequest;

  if (hrProvider === 'workable') {
    // Use AJAX proxy for Workable (keeps token secure)
    // eslint-disable-next-line no-undef
    breezyCareersApiRequest = apiRequestJSON('GET', ajaxUrl, 'get_careers_jobs', { nonce: map_block_object.nonce })
      .then(response => {
        // AJAX wrapper returns {success: true, data: [...]}
        return response.success ? response.data : [];
      });
  } else {
    // Use direct Breezy endpoint (backward compatible)
    // eslint-disable-next-line no-undef
    breezyCareersApiRequest = map_block_object.breezy_endpoint
      // eslint-disable-next-line no-undef
      ? apiRequestJSON('GET', map_block_object.breezy_endpoint)
      : Promise.resolve([]);
  }

  Promise.all([postsApiRequest, breezyCareersApiRequest])
    .then(([posts, careers]) => {
      // Ensure careers is always an array (handle null/undefined/error responses)
      breezyCareers  = Array.isArray(careers) ? careers : [];
      postData = posts.data || [];

      const initSelectOptionValues = () => {
        const employmentTypes = getPropsCareers('employmentTypes', breezyCareers);
        const departments = getPropsCareers('departments', breezyCareers);

        slcLocation.value = slcLocation[0].value;
        slcEmployment.value = slcEmployment[0].value;
        slcJobType.value = slcJobType[0].value;

        if(hrProvider === 'workable') {
          const locations = getPropsCareers('locations', breezyCareers);
          if(locations)
            setOptionValue(slcLocation, locations);
        } else {
          const locations = map(postData, 'post_title');
          if(locations)
            setLocationOptionValue(slcLocation, postData);
        }

        if(employmentTypes)
          setOptionValue(slcEmployment, employmentTypes);

        if(departments)
          setOptionValue(slcJobType, departments);
      }

      // init maps
      import('../map/map.js').then( res => {
        const locations = filterPostsCareers(postData, breezyCareers);

        mapObj = res;
        mapObj.init(locations);
      });

      const setMapMarker =  () => {
        let careerFilters = {
          location: slcLocation.value,
          employmentType: slcEmployment.value,
          department: slcJobType.value
        }

        careerFilters = omitBy(careerFilters, value => !value);

        const resCareers = getFilterCareers( breezyCareers , careerFilters, hrProvider === 'breezy' ? postData : null);

        if(resCareers.length) {
          const locations = filterPostsCareers(postData, resCareers);
          mapObj?.filterMap(null, locations);
        }

        setHrOpenings(resCareers);
      }

      const JOBS_PER_PAGE = 8;

      const buildCard = (hrOpening) => {
        const locationHtml = hrOpening.location?.name ? `<p>${hrOpening.location.name}</p>` : '';
        const typeHtml = hrOpening.type?.name ? `<p>${hrOpening.type.name}</p>` : '';
        const deptHtml = hrOpening.department ? `<p>${hrOpening.department}</p>` : '';
        return jQuery(`<div class="card" data-url="${hrOpening.url}">
                <div class="card-body text-center">
                    <h4 class="card-title h4 text-uppercase mb-0" role="heading">${hrOpening.name}</h4>
                    <div class="content">
                        ${locationHtml}
                        ${typeHtml}
                        ${deptHtml}
                    </div>
                    <div class="wp-block-button has-btn-secondary"><a href="${hrOpening.url}" class="wp-block-button__link wp-element-button" target="_blank">Apply now</a></div>
                </div>
              </div>`);
      }

      const setHrOpenings = (hrOpenings) => {
        const $element = jQuery(careerContainer);
        $element.empty();

        if(hrOpenings.length) {
          const visibleJobs = hrOpenings.slice(0, JOBS_PER_PAGE);
          const hiddenJobs = hrOpenings.slice(JOBS_PER_PAGE);

          visibleJobs.forEach(hrOpening => {
            $element.append(buildCard(hrOpening));
          });

          if(hiddenJobs.length) {
            const $showMore = jQuery(`<div class="block-careers__show-more" style="grid-column: 1/-1; text-align: center;">
                    <div class="wp-block-button has-btn-secondary">
                        <a href="#" class="wp-block-button__link wp-element-button show-more-btn">Show More</a>
                    </div>
                  </div>`);

            $element.append($showMore);

            $showMore.on('click', '.show-more-btn', (e) => {
              e.preventDefault();
              $showMore.remove();
              hiddenJobs.forEach(hrOpening => {
                $element.append(buildCard(hrOpening));
              });
            });
          }
        }else {
          $element.append(`<p style="text-align: center; grid-column: 1/6;"><strong>Sorry, but nothing matched your search terms.</strong></p>`);
        }

        $element.on('click', '.card', (e) => {
          e.preventDefault();
          const el = e.currentTarget;
          const url = el.dataset.url;

          window.open(url, '', 'width=1200,height=800');
        })
      }

      // events
      slcLocation.addEventListener('change', (e) => {
        const resCareers = getFilterCareers( breezyCareers , { location: e.currentTarget.value }, hrProvider === 'breezy' ? postData : null);

        setOptionValue(slcJobType, getPropsCareers('departments', resCareers));
        setOptionValue(slcEmployment, getPropsCareers('employmentTypes', resCareers));

        setMapMarker();
      });

      slcJobType.addEventListener('change', (e) => {
        const resCareers = getFilterCareers( breezyCareers , { department: e.currentTarget.value });

        setOptionValue(slcEmployment, getPropsCareers('employmentTypes', resCareers));
        setMapMarker();
      });

      slcEmployment.addEventListener('change', (e) => {
        const resCareers = getFilterCareers( breezyCareers ,  { employmentType: e.currentTarget.value });

        setOptionValue(slcJobType, getPropsCareers('departments', resCareers));
        setMapMarker();
      });

      // clear reset
      btnClearFilters.addEventListener('click', (e) => {
        e.preventDefault();
        const locations = filterPostsCareers(postData, breezyCareers);

        initSelectOptionValues();
        setHrOpenings(breezyCareers);

        mapObj.filterMap(null, locations);
        mapObj.closeMobileInfo();
        mapObj.closeLargeInfo();
      });

      //
      initSelectOptionValues();
      setHrOpenings(breezyCareers);

    })
    // eslint-disable-next-line no-console
    .catch(response => console.error(response));
}

//-----------------------------------------------------------------------------
/**
 *  HELPERS FUNCTIONS
 */

async function  apiRequestJSON (method, url, action = null, params = {}) {
  let urlParams = url;

  if(action)
    urlParams += `?action=${action}&`;

  for (const key in params) {

      // eslint-disable-next-line no-prototype-builtins
      if (params.hasOwnProperty(key)) {
          urlParams+= `${key}=${params[key]}&`
      }
  }
  const response = await fetch(urlParams, {
      method,
      credentials: 'same-origin',
      headers: {
      'Content-Type': 'application/json'
      },
  });
  return response.json(); // parses JSON response into native JavaScript objects
}

function setOptionValue(element, values) {
  const initialValue = element.options[element.selectedIndex].text;

  if(element.classList.contains('skeleton')) {
      element.classList.remove('skeleton');
      element.disabled = false;
  }

  // remove unnecessary values
  if(element.length > 1) {
    element.querySelectorAll('option').forEach((option, index) => {
      if(index > 0) 
        option.remove();
    })
  }

  values.forEach((value, key) => {
    element[key + 1] = new Option(value, value, false, initialValue === value);
  });
}

function setLocationOptionValue(element, locations) {
  const initialValue = element.options[element.selectedIndex].text;

  if(element.classList.contains('skeleton')) {
      element.classList.remove('skeleton');
      element.disabled = false;
  }

  // remove unnecessary values
  if(element.length > 1) {
    element.querySelectorAll('option').forEach((option, index) => {
      if(index > 0) 
        option.remove();
    })
  }

  locations = sortBy(locations, 'post_title');

  locations.forEach((value, key) => {
    const {ID, post_title: title} = value;
    element[key + 1] = new Option(title, ID, false, initialValue === title);
  });
}

function getFilterCareers(careers, obj, locations = null) {
  let result = cloneDeep(careers);

  const filterHandler = {
    location: (values) => {
      // Workable: match by location.name directly
      if (!locations) {
        return filter(values,
          (value) => value?.location?.name?.toLowerCase() === obj.location.toLowerCase());
      }

      // Breezy: match via WP location posts
      const location = filter(locations, {ID: +obj.location});
      let filteredCareers = [];

      if(location[0]?.hr_breezy_locations) {
        location[0]?.hr_breezy_locations.forEach(hrLocation => {
            const results = filter(values,
              (value) => value?.location?.state?.id.toLowerCase() === hrLocation?.state_id.toLowerCase() &&
              value?.location?.city?.toLowerCase() === hrLocation?.city?.toLowerCase() );
              filteredCareers = union(filteredCareers, results);
          });
      }

      if(location[0]?.map_location) {
        const results = filter(values,
          (value) => value?.location?.state?.id.toLowerCase() === location[0]?.map_location?.state_short?.toLowerCase() &&
          value?.location?.city?.toLowerCase() === location[0]?.map_location?.city?.toLowerCase() );
          filteredCareers = union(filteredCareers, results);
      }

      return filteredCareers;
    },
    department: (values) => {
      const filteredCareers = filter(values, 
        (value) => value?.department?.toLowerCase() === obj.department.toLowerCase());

      return filteredCareers;
    },
    employmentType: (values) => {
      const filteredCareers = filter(values, 
        (value) => value?.type?.name.toLowerCase() === obj.employmentType.toLowerCase());

      return filteredCareers;
    }
  }

  Object.keys(obj).forEach(key => {
    result = filterHandler[key](result);
  });

  return result;
}

function filterPostsCareers(posts, careers) {
  const filteredPosts = [];

  careers.forEach(career => {
    posts.forEach(post => {

      if(post?.hr_breezy_locations?.length) {
        const hrLocations = map(post?.hr_breezy_locations, (breezyLocation) => `${breezyLocation.city.toLowerCase()}, ${breezyLocation.state_id.toLowerCase()}`);

        if(hrLocations.includes(`${career?.location?.city?.toLowerCase()}, ${career.location.state.id.toLowerCase()}`)) {
          filteredPosts.push(post);
        }
      }else if(post.map_location) {
          if(career?.location?.city?.toLowerCase() === post?.map_location?.city?.toLowerCase() && 
          career?.location?.state?.id.toLowerCase() === post?.map_location?.state_short?.toLowerCase()) {
            filteredPosts.push(post);
          }
        }
    })
  });

  if(filteredPosts.length)
    return uniqBy(filteredPosts, 'ID')

  return filteredPosts;
}

function getPropsCareers(props, careers) {
  let values = [];

  switch( props ) {
    case 'locations':
      values = map(careers, (value) => { return value.location.name});
    break;
    case 'employmentTypes':
      values = map(careers, (value) => { return value.type.name});
    break;
    case 'departments':
      values = map(careers, (value) => { return value.department});
    break;
  }

  return orderBy(
        uniqWith(
        filter(values, value => !!value), 
      (a,b) => a.toLowerCase() === b.toLowerCase()));
}

//----------------------------------------------------------------
document.addEventListener( 'DOMContentLoaded', () => {
  const blocks = document.querySelectorAll('.block-careers');
    blocks.forEach(block => initCareers(block));
} );